import React from 'react';
import { Col, Row } from 'reactstrap';
import { ScorecardCategory } from './ScorecardCategory';
import { Scorecard } from '../../../../../../entities/applicant_tracking/Scorecard';
import { User } from '../../../../../../entities/User';
import { Section } from '../../../../../../entities/v1/survey_engine/Section';
import { Survey } from '../../../../../../entities/v1/survey_engine/Survey';

interface PropTypes {
  fillColorClass?: string;
  scorecard: Scorecard;
  setScorecard: (scorecard: Scorecard) => void;
  user?: User;
  className?: string;
}

export function ScorecardCategories(props: PropTypes) {
  return (
    <Row>
      {props.scorecard.survey.sections.map(
        (section: Section, index: number) => {
          return (
            <Col key={index} xs='6'>
              <ScorecardCategory
                scorecardId={props.scorecard.id}
                editable={props.user?.id === props.scorecard.user?.id}
                survey={props.scorecard.survey}
                category={section}
                attributes={section.questions}
                setSurvey={(survey: Survey) =>
                  props.setScorecard({ ...props.scorecard, survey })
                }
                fillColorClass={props.fillColorClass}
                className={props.className}
              />
            </Col>
          );
        },
      )}
    </Row>
  );
}
